import { assetsPath } from "../../utils";

export default {
  title: "The Santuary Club",
  description: {
    en:
      "Experience ultimate lifestyle within worldwide network under the Banyan Group. Membership is exclusively offered to the owners of Laguna, Banyan Tree, Angsana and Cassia properties only.",
    cn:
      "体验悦榕集团全球网络内的终极生活方式。仅向乐古浪、悦榕庄、悦椿和悦梿物业的业主提供会员权益。",
    ru:
      "Наслаждайтесь роскошным стилем жизни, пользуясь глобальной сетью компании Banyan Group. Членство предлагается только владельцам собственности в рамках проектов Laguna, Banyan Tree, Angsana и Cassia.",
  },
  image: `${assetsPath("phuket-skypark")}/images/the-sanctuary-club/image.jpg`,
};



// WEBPACK FOOTER //
// ./src/data/PhuketSkypark/sanctuaryClub.js